module.exports = __webpack_public_path__ + "media/images/icons/download-481a514c8d1a9cd6e5cdec8a7c8b96e4.svg";